import moment from 'moment';
import React, { useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { sendConfirmationEmail } from '../api/api';

const RegistrationSuccess = ({ setIsRegistered, registeredData }) => {
  const [email, setEmail] = useState('');
  const [err, setErr] = useState('');

  const sendMail = async () => {
    if (!email) {
      setErr('Please enter an email address');
      return;
    }

    if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      setErr('Please enter a valid email address');
      return;
    }

    setErr('');
    // Add API call here
    const res = await sendConfirmationEmail(email, registeredData._id);
    console.log(res);
    toast.success(res.message);

    // Reset form
    setEmail('');
  }

  return (
    <div>
      <div className="flex items-center justify-center bg-transparent text-white font-montserrat px-4">
        <div className="w-full max-w-sm p-6 text-center">

          {/* Thank you text */}
          <h2 className="text-xl font-semibold mb-6">Thank you for registering</h2>

          {/* Car Number */}
          <div className="flex items-baseline gap-3 mb-4 text-left">
            <img
              src="./car.png"
              alt="Car"
            />
            <div>
              <p className="text-base font-medium uppercase">{registeredData?.plateNumber}</p>
            </div>
          </div>

          {/* Building & Unit */}
          <div className="flex items-baseline gap-3 mb-4 text-left">
            <img
              src="./building.png"
              alt="Building"
            />
            <div>
              <p className="text-base font-medium">
                {registeredData?.building.name}
              </p>
              <p className="text-xs">Unit {registeredData?.unitNumber}</p>
            </div>
          </div>

          {/* Date & Time */}
          <div className="flex items-baseline gap-3 mb-6 text-left">
            <img
              src="./calendar.png"
              alt="Calendar"
            />
            <div>
              <p className="text-base">{moment.parseZone(registeredData?.startTime).format('MMMM D, YYYY [at] h:mma')}</p>
              <p className="text-base">to</p>
              <p className="text-base">{moment.parseZone(registeredData?.endTime).format('MMMM D, YYYY [at] h:mma')}</p>
            </div>
          </div>

          {/* Button */}
          <button className="w-full bg-cyan-500 hover:bg-cyan-600 text-white py-2 rounded font-semibold transition" onClick={() => setIsRegistered(false)}>
            BACK TO REGISTRATION
          </button>
        </div>
      </div>

      <div className="flex items-center justify-center bg-transparent text-white font-montserrat px-4">
        <div className="w-full max-w-sm p-6">
          {/* Email */}
          <h1 className='text-xl font-semibold mb-2'>Send a confirmation email</h1>
          <div>
            <label className="text-sm block mb-1 text-left">Email address:</label>
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => { setEmail(e.target.value); setErr('') }}
              className="w-full px-3 py-2 bg-black border border-gray-700 rounded text-white"
              placeholder="Enter email"
            />
            {err && (
              <p className="text-red-400 text-sm mt-1 text-left">{err}</p>
            )}
          </div>
          <button
            type="button"
            className="w-full bg-teal-500 hover:bg-teal-600 text-white py-2 rounded mt-4"
            onClick={sendMail}
          >
            Send Confirmation
          </button>
        </div>
      </div>
      <ToastContainer
        closeButton={false}
        autoClose={5000}
        position='top-right'
      />
    </div>
  );
};

export default RegistrationSuccess;
